<template>
    <main>

       <div id="map-wrap" style="height: 100vh; z-index: 1; position:relative">
            <no-ssr>
                <l-map :zoom=13 :center="[latitude, longitude]">
                    <l-tile-layer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"></l-tile-layer>
                    <l-circle :lat-lng="[latitude, longitude]" color='rgba(0,0,0,.0)' fillColor="#3388FF" :radius="100"></l-circle>
                    <!--<l-circle v-if="!selected.selected" :lat-lng="[latitude, longitude]" color='red' fillColor="#f03" :radius="500"></l-circle>-->
                    
                    <l-circle-marker v-if="latitudeCollect!=0" :lat-lng="[latitudeCollect, longitudeCollect]" fillColor="#3388FF" color="#fff" :fillOpacity="1"  @add="$nextTick(() =>$event.target.openPopup())">
                        <l-popup >
                            <div class="J-map-container">
                                <div class="J-map-title">
                                    <b>Cliente: </b>{{nameuser}}
                                </div>
                                <div class="J-map-user-data" v-if="home">
                                    <div class="J-map-direction" v-if="home.collect.direction!=''">
                                        <b>Dirección de recojo:</b> {{home.collect.direction}}
                                        <div>
                                            <span><b>Fecha de recojo:</b> {{moment(home.collect.datetime.datetime).format('DD-MM-YYYY HH:mm')}} </span>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <b>NOTA:</b> El cliente llevara sus prendas a la lavanderia
                                    </div>
                                </div>
                            </div>
                        </l-popup>
                    </l-circle-marker>
                    <l-circle-marker v-if="latitudeDelivery!=0" :lat-lng="[latitudeDelivery, longitudeDelivery]" fillColor="#3388FF" color="#fff" :fillOpacity="1">
                        <l-popup >
                            <div class="J-map-container">
                                <div class="J-map-title">
                                    <b>Cliente: </b>{{nameuser}}
                                </div>
                                <div class="J-map-user-data" v-if="home">
                                    <div class="J-map-direction" v-if="home.delivery.direction!=''">
                                        <b>Dirección de entrega:</b> {{home.delivery.direction}}
                                        <div>
                                            <span><b>Fecha de entrega:</b> {{moment(home.delivery.datetime.datetime).format('DD-MM-YYYY HH:mm')}}</span>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <b>NOTA:</b> El cliente recogera sus prendas en la lavanderia
                                    </div>
                                </div>
                            </div>
                        </l-popup>
                    </l-circle-marker>
                     <l-circle v-if="selected.selected" :lat-lng="[selected.latitude, selected.longitude]" color="rgba(0,0,0,.0)" fillColor="rgb(7, 232, 244)" :radius="100"></l-circle>
                    <l-circle-marker v-for="(item,index) in newMaker" :key="index" :lat-lng="[item.latitude, item.longitude]" fillColor="#07e8f4" color="#fff" :fillOpacity="1">
                        <l-popup>
                            <label>Tu ubicación</label>
                        </l-popup>
                    </l-circle-marker>
                    <l-circle-marker v-if="latitudeCollect==0&latitudeDelivery==0" :lat-lng="[latitude, longitude]" fillColor="#3388FF" color="#fff" :fillOpacity="1"  @add="$nextTick(() =>$event.target.openPopup())">
                        <l-popup >
                            <div class="J-map-container">
                                <div class="J-map-title">
                                    <b>Cliente: </b>{{nameuser}}
                                </div>
                                <div class="J-map-user-data" v-if="home">
                                    <div class="J-map-direction" v-if="home.collect.direction!=''">
                                        <b>Dirección de recojo:</b> {{home.collect.direction}}
                                        <div>
                                            <span><b>Fecha de recojo:</b> {{moment(home.collect.datetime.datetime).format('DD-MM-YYYY HH:mm')}} </span>
                                        </div>
                                    </div>
                                    <div class="J-map-direction" v-if="home.phone!=''&&home.phone!=undefined">
                                        <b>Numero de contacto:</b> {{home.phone}}
                                    </div>
                                    <div v-else-if="category=='lavanderia'">
                                        <b>NOTA:</b> El cliente llevara sus prendas a la lavanderia
                                    </div>
                                    <div class="J-map-direction" v-if="home.delivery.direction!=''">
                                        <b>Dirección de entrega:</b> {{home.delivery.direction}}
                                        <div>
                                            <span><b>Fecha de entrega:</b> {{moment(home.delivery.datetime.datetime).format('DD-MM-YYYY HH:mm')}}</span>
                                        </div>
                                    </div>
                                    <div v-else-if="category=='lavanderia'">
                                        <b>NOTA:</b> El cliente recogera sus prendas en la lavanderia
                                    </div>
                                    <div v-else>
                                        <b>NOTA:</b> El cliente vendra a recoger su pedido
                                    </div>
                                </div>
                            </div>
                        </l-popup>
                    </l-circle-marker>
                </l-map>
            </no-ssr>
        </div>
        <input v-model="channel.channelCompany" placeholder="channel"/>
        <input v-model="channel.id" placeholder="id">
    </main>
</template>
<script>
// var popupcontent = '<br><button class="btn btn-warning btn-sm" style="color: white;margin:5% 0% 0% 35%;" @click="addStops(' + loc + ')">Add</button>'
import { LMap, LTileLayer, LMarker,LPopup,LCircle,LCircleMarker } from 'vue2-leaflet';
import { EventBus } from '../../../../helpers/eventbus/event-bus';
import moment from 'moment'
// import selected from 'selected';
export default {
    data(){
        return {
            isuser:false,
            nameuser:'',
            session:false,
            home:null,
            moment:moment,
            direction:null,
            latitude:0,
            longitude:0,
            latitudeCollect:0,
            longitudeCollect:0,
            latitudeDelivery:0,
            category:0,
            phone:'',
            longitudeDelivery:0,
            marker:[
                
            ],
            locationFirst:false,
            selected:{
                selected:false,
                latitude:null,
                longitude:null,
            },
            newMaker:[],
            layers:[
                {
                    id: 0,
                    name: 'Restaurants',
                    active: false,
                    features: [ /* snip */ ],
                },
                {
                    id: 1,
                    name: 'City/County Boundaries',
                    active: false,
                    features: [],
                }
            ],
            channel:{
                channelCompany:'',
                id:1,
            }
        }
    },
    
    mounted(){
        this.session = JSON.parse(localStorage.getItem('user'))
        if(!this.session){
            this.$router.back();
        }
        var {longcompany,latcompany,fullname,home,category}=this.$route.query;

        this.category=category;
        if(home!='undefined'){
            home=JSON.parse(home);
            this.home=home;
            this.phone=home.phone||'';
            if(home.collect.location.length!=0&home.delivery.location.length!=0){


               if(home.collect.location[0]==home.delivery.location[0]){
                    this.latitude = home.collect.location[0]
                    this.longitude = home.collect.location[1]
                } 
                else{

                    this.latitude = home.collect.location[0]
                    this.longitude = home.collect.location[1]
                    this.latitudeCollect = home.collect.location[0]
                    this.longitudeCollect = home.collect.location[1]

                    this.latitudeDelivery = home.delivery.location[0]
                    this.longitudeDelivery = home.delivery.location[1]

                }
            }
            else if(home.collect.location.length!=0){

                this.latitude = home.collect.location[0]
                this.longitude = home.collect.location[1]
            }
            else if(home.delivery.location.length!=0){
                
                this.latitude = home.delivery.location[0]
                this.longitude = home.delivery.location[1]
            }
            else{
                this.latitude = latcompany
                this.longitude = longcompany
    
            }
        }
        this.nameuser = fullname
        this.newMaker=[
            {latitude:latcompany,longitude:longcompany,channel:'channel101'},
        ]
    },
    components:{
        LMap, LTileLayer, LMarker,LPopup,LCircle,LCircleMarker
    },
    methods:{
        
        
        menushow(){
                document.getElementById("sidebar").style = `
                    transform: translateX(0);
                `
        },
        menuhide(){
                    document.getElementById("sidebar").style = `
                        translateX(-100%);
                    `
        },
        
        sendRoom:function(data){
            this.$socket.emit('room',data.channel);
        },
        checkedLocation:function(){
            this.locationFirst=true;
            var i=1;
            var me =this;
            var interval= setInterval(function(){
                var position=me.recuvaLocation;
                if(position.latitude!=me.latitude&&position.longitude!=me.longitude){
                    me.longitude=position.longitude;
                    me.latitude=position.latitude;
                    me.sendLocation();
                }
            },5000)
        },
        
        
    }
}
</script>